/** Only used when resourceFirstArchitectureDemo flag is on */
import {
  type ResourceTrigger,
  type ResourceTriggerCreateBody,
  type ResourceTriggerUpdateBody,
  type ResourceTriggerWatchListQuery,
} from 'resource-gateway-schema';

import { type Common } from '../common.js';

export class API {
  common: Common;
  baseEndpoint = '/resource-gateway/resource-trigger/watch';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams: ResourceTriggerWatchListQuery): Promise<ResourceTrigger[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<ResourceTrigger> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async create(values: ResourceTriggerCreateBody): Promise<{ id: string }> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(id: string, values: ResourceTriggerUpdateBody): Promise<ResourceTrigger> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.putJSON(url, values);
  }

  async delete(id: string): Promise<void> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    await this.common.deleteJSON(url);
  }
}
